"use client"

import { QueryClientProvider } from "@tanstack/react-query"
import type * as React from "react"
import getQueryClient from "./getQueryClient"

export interface QueryProviderProps {
  children: React.ReactNode
}

export const QueryProvider: React.FunctionComponent<QueryProviderProps> = ({
  children,
}) => {
  const queryClient = getQueryClient()
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  )
}
